import { setAddToCartContent } from './fill-wc-add-to-cart';
import { setProductPriceContent } from './fill-wc-price';
import { setStockContent } from './fill-wc-stock';

const productData = {
	fromWc: [],
};

/**
 * Use custom ajax endpoint to get product data directly from WooCommerce
 * Reason for this is some of these:
 * - Product prices could be based on the logged in user
 * - Prices may be modified by some plugins / hooks
 * - Stock might be controlled by some third party solution
 * - etc..
 *
 * @param {Object} productsSeenNow
 * @param {Object} productsSeenAgain
 */
export const getProductDataFromWooCommerce = (
	productsSeenNow,
	productsSeenAgain
) => {
	/**
	 * If we already have data, use that
	 */
	if ( Object.keys( productsSeenAgain ).length ) {
		Object.keys( productsSeenAgain ).forEach( ( key ) => {
			const existingData = productData.fromWc.filter( ( data ) => {
				return (
					Number( data.product_id ) ===
					productsSeenAgain[ key ].product_id
				);
			} );
			setTimeout( () => {
				fillAlgoliaProductWithWooCommerceData(
					String( productsSeenAgain[ key ].product_id ),
					existingData[ 0 ]
				);
			}, 1000 );
		} );
	}

	/**
	 * If we dont have data, fill with data from WooCommerce
	 */
	if ( Object.keys( productsSeenNow ).length ) {
		jQuery
			.ajax( {
				type: 'POST',
				url: MWC_AIS.ajax_url,
				data: {
					action: 'get_mwc_ais_product_data',
					products: productsSeenNow,
				},
			} )
			.done( function ( ajaxResult ) {
				if ( ! ajaxResult.success ) {
				} else if (
					ajaxResult.products &&
					Object.keys( ajaxResult.products ).length
				) {
					Object.keys( ajaxResult.products ).forEach(
						( productId ) => {
							productData.fromWc.push(
								ajaxResult.products[ productId ]
							);
							fillAlgoliaProductWithWooCommerceData(
								productId,
								ajaxResult.products[ productId ]
							);
						}
					);
				}
			} );
	}
};

/**
 * Function to collect what data should be filled from WooCommerce
 *
 * @param {string} productId
 * @param {Object} product
 */
const fillAlgoliaProductWithWooCommerceData = ( productId, product ) => {
	if ( MWC_AIS.show_stock_status === 'yes' ) {
		setStockContent( productId, product );
	}

	if ( MWC_AIS.show_prices === 'yes' ) {
		setProductPriceContent( productId, product );
	}

	if ( MWC_AIS.show_buy === 'yes' ) {
		setAddToCartContent( productId, product );
	}
};
